(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-buy-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getHashFromHref = (href) => {
      if (!href || href === '#') return null;
      if (href.startsWith('#')) return href.length > 1 ? href : null;
      try {
        const url = new URL(href, window.location.href);
        if (url.pathname !== window.location.pathname || url.origin !== window.location.origin) return null;
        return url.hash && url.hash.length > 1 ? url.hash : null;
      } catch {
        return null;
      }
    };

    const initFloatingBuyBar = (root) => {
      if (!root || root.dataset.floatingBuyBarInitialized === 'true') return;
      root.dataset.floatingBuyBarInitialized = 'true';

      if (root.hasAttribute('data-reveal-offset')) {
        const revealOffset = Number(root.dataset.revealOffset) || 0;
        // Since Horizon 4 the desktop scroll container is .page-wrapper
        // (html/body are overflow:hidden); on mobile the window scrolls.
        // A capturing document listener sees scrolls of both.
        const pageWrapper = document.querySelector('.page-wrapper');
        const getScrollTop = () => Math.max(window.scrollY, pageWrapper ? pageWrapper.scrollTop : 0);
        let pinnedByEditor = false;
        const update = () => {
          if (!root.isConnected) return;
          root.toggleAttribute('data-visible', pinnedByEditor || getScrollTop() > revealOffset);
        };
        document.addEventListener('scroll', update, { capture: true, passive: true });
        update();

        if (window.Shopify && window.Shopify.designMode) {
          const section = root.closest('.shopify-section');
          document.addEventListener('shopify:section:select', (event) => {
            if (event.target !== section) return;
            pinnedByEditor = true;
            update();
          });
          document.addEventListener('shopify:section:deselect', (event) => {
            if (event.target !== section) return;
            pinnedByEditor = false;
            update();
          });
        }
      }

      const links = Array.from(root.querySelectorAll('[data-fbb-link]'));
      if (!links.length) return;

      const setActiveLink = (activeLink) => {
        links.forEach((link) => {
          link.removeAttribute('data-active');
          link.removeAttribute('aria-current');
        });
        if (activeLink) {
          activeLink.setAttribute('data-active', '');
          activeLink.setAttribute('aria-current', 'true');
        }
      };

      const scrollToTarget = (target) => {
        // Since Horizon 4 the desktop scroll container is .page-wrapper
        // (html/body are overflow:hidden); on mobile the window scrolls.
        const pageWrapper = document.querySelector('.page-wrapper');
        const scroller = pageWrapper && getComputedStyle(pageWrapper).overflowY === 'auto' ? pageWrapper : null;
        const currentScroll = scroller ? scroller.scrollTop : window.scrollY;
        const y = target.getBoundingClientRect().top + currentScroll - root.offsetHeight - 16;
        (scroller || window).scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      };

      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const hash = getHashFromHref(link.getAttribute('href'));
          setActiveLink(link);
          if (!hash) return;
          const target = document.querySelector(hash);
          if (!target) return;
          event.preventDefault();
          scrollToTarget(target);
          history.pushState(null, '', hash);
        });
      });
    };

    document.querySelectorAll('[data-floating-buy-bar]').forEach(initFloatingBuyBar);

    // The theme editor re-renders the section on every setting change and
    // does not re-run this script — re-init the fresh DOM node.
    document.addEventListener('shopify:section:load', (event) => {
      const bar = event.target.querySelector('[data-floating-buy-bar]');
      if (bar) initFloatingBuyBar(bar);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
